// ============================================================
//  Traductions françaises — fr.ts
// ============================================================
import { NotificationType } from "../models/notification_type";
const fr = {

  // ── Commun ───────────────────────────────────────────────
 common: {
  save:        "Enregistrer les modifications",
  saving:      "Sauvegarde...",
  loading:     "Chargement...",
  cancel:      "Annuler",
  confirm:     "Confirmer",
  delete:      "Supprimer",
  edit:        "Modifier",
  back:        "Retour",
  search:      "Rechercher",
  noResults:   "Aucun résultat",
  error:       "Une erreur est survenue",
  success:     "Opération réussie",
  copyEmail:   "Copier l'email",
  copied:      "Copié !",
  yes:         "Oui",
  no:          "Non",
  continue: "Continuer",
  deleteConfirmTitle: "Confirmer la suppression",
  saveConfirmTitle: "Confirmer l'enregistrement",
  logoutTitle: "Se déconnecter ?",
  logoutContent: "Voulez-vous vraiment vous déconnecter de votre compte ?",
  logoutConfirm: "Se déconnecter",


},

updateExpenseStatus: {
    title: "Mettre à jour le statut de la note de frais",
    currentStatus: "Statut actuel :",
    confirmTransition: "Voulez-vous vraiment changer le statut de cette note de frais en {status} ?",
    updateSuccess: "Le statut de la note de frais a été mis à jour en {status}",
    updateError: "Échec de la mise à jour du statut",
    approve: "Approuver",
    reject: "Rejeter",
    markReimbursed: "Marquer comme remboursée",
    noTransition: "Aucune transition de statut disponible pour cette note de frais.",
    back: "Retour",
    loading: "Chargement de la note de frais...",
    error: "Erreur : ",
    notFound: "Note de frais introuvable",
  },
resiliation: {
    warningTitle: "Quitter Notacito",
    warningDesc1: "Cette action est",
    warningDescIrreversible: "irréversible",
    warningDesc2: ". Elle entraîne la",
    warningDescImmediate: "résiliation immédiate",
    warningDesc3: "de votre abonnement et la",
    warningDescClosure: "fermeture définitive",
    warningDesc4: "de votre compte.",
    warningPoint1: "Votre abonnement actif est annulé sans remboursement au prorata",
    warningPoint2: "L'accès à l'ensemble des fonctionnalités Notacito est révoqué immédiatement",
    warningPoint3: "Tous les membres de votre entreprise perdent leur accès",
    warningPoint4: "Vous choisissez ce qu'il advient de vos données à l'étape suivante",

    step1Label: "Étape 1 sur 2",
    dataChoiceTitle: "Que faire de vos données ?",
    dataChoiceDesc: "Choisissez ce qu'il advient de toutes les données associées à votre compte (fichiers, historique, rapports, paramètres).",
    keepDataTitle: "Conserver mes données",
    keepDataDesc1: "Vos données restent archivées indéfiniment. Vous pouvez en demander un export à tout moment en écrivant à",
    deleteDataTitle: "Supprimer toutes mes données",
    deleteDataDesc1: "Toutes vos données sont",
    deleteDataDescStrong: "définitivement et irrémédiablement effacées",
    deleteDataDesc2: ". Aucune récupération possible après confirmation.",

    step2Label: "Étape 2 sur 2 — Confirmation finale",
    confirmDeleteTitle: "Confirmer la suppression",
    confirmKeepTitle: "Confirmer la résiliation",
    confirmDeleteDesc1: "Vous avez choisi de",
    confirmDeleteDescStrong: "supprimer définitivement",
    confirmDeleteDesc2: "toutes vos données. Pour confirmer, saisissez",
    confirmDeleteDesc3: "ci-dessous.",
    confirmKeepDesc1: "Vous avez choisi de",
    confirmKeepDescStrong: "conserver vos données",
    confirmKeepDesc2: ". Elles resteront archivées et exportables sur demande. En cliquant sur « Confirmer », votre compte sera définitivement fermé.",

    summaryResiliation: "Résiliation",
    summaryImmediate: "Immédiate",
    summaryData: "Données",
    summaryDataDeleted: "Supprimées définitivement",
    summaryDataKept: "Conservées & exportables",

    confirmingBtn: "En cours…",
    confirmLeaveBtn: "Confirmer et quitter",

    doneTitle: "Votre compte a été clôturé",
    doneMessageDeleted: "Toutes vos données ont été supprimées. Merci d'avoir utilisé Notacito.",
    doneMessageKept: "Votre compte est fermé. Vos données sont conservées — contactez-nous à tout moment pour un export.",
    redirecting: "Vous allez être déconnecté automatiquement dans quelques instants…"
  },

featureGate: {
  subscriptionRequired: "Abonnement requis",
  featureName: "Fonctionnalité Premium",
  unlock: "Débloquez ",
  upgrade: "Voir les offres",
  neededPlan: "Vous devez souscrire à un abonnement pour accéder à cette page.",
  morePlan: "Passez au forfait supérieur pour y accéder.",
},

topHeader: {
  activateTrial: "Activer mon essai gratuit",
},


  // ── Navigation ───────────────────────────────────────────
  nav: {
  dashboard: "Tableau de bord",
  members: "Membres",
  users: "Utilisateurs",
  admins: "Administrateurs",
  accountants: "Comptables",
  clients: "Clients",
  expenses: "Notes de frais",
  categories: "Catégories",
  offices: "Bureaux",
  companyPolicies: "Politiques d'entreprise",
  corporate: "Entreprise",
  settings: "Paramètres",
  openMenu: "Ouvrir le menu",
notacitoLogo: "Logo Notacito",
  account: "Mon compte",
  manageSubscription: "Gérer mon abonnement",
  logout: "Se déconnecter",
  help: "Aide",

  profileOverview: "Aperçu du profil",
  options: "Options",
  defaultUser: "Utilisateur",

  expandMenu: "Agrandir le menu",
  collapseMenu: "Réduire le menu",

  plusDescription:
    "Débloquez toutes les fonctionnalités d'administration.",
  viewOffer: "Voir l'offre",
},

  // ── Page Mon Compte ──────────────────────────────────────
  account: {
    pageTitle:          "Gérer mon compte",
    sidebarLabel:       "Gérer mon compte",
    myAccount:          "Mon compte",
    security:           "Sécurité",
    manageSubscription: "Gérer mon abonnement",
    myProfile:          "Mon profil",
    firstName:          "Prénom",
    lastName:           "Nom",
    myEmail:            "Mon email",
    verified:           "✓ VÉRIFIÉ",
    phone:              "Téléphone",
    phonePlaceholder:   "+33 6 00 00 00 00",
    toastSuccess:       "Profil mis à jour !",
    toastError:         "Erreur : ",
  },

  // ── Préférences ──────────────────────────────────────────
  preferences: {
    title:      "Préférences",
    language:   "Langue",
    theme:      "Thème",
    lightMode:  "Mode Clair",
    darkMode:   "Mode Sombre",
  },

  // ── Sécurité ─────────────────────────────────────────────
  security: {
    title:        "Sécurité",
    description:  "Gérez la sécurité de votre compte administrateur.",
    password:     "Mot de passe",
    lastModified: "Dernière modification : inconnue",
    dangerZone:   "Zone de danger",
    dangerDesc:   "Actions irréversibles sur votre compte.",
    logout:       "Se déconnecter",
  },

  // ── Abonnement ───────────────────────────────────────────
  subscription: {
    title:          "Mon abonnement",
    description:    "Gérez votre plan et vos options de facturation.",
    freePlanDesc:   "Vous êtes sur le plan gratuit. Passez à Notacito Plus pour débloquer toutes les fonctionnalités.",
    activePlanDesc: "Votre abonnement est actif. Merci de votre confiance !",
    upgradeCta:     "⭐ Passer à Plus",
    status:         "Statut",
    plan:           "Plan",
    cancelZoneTitle: "Résilier l'abonnement",
    resiliationZoneTitle: "Quitter Notacito",
    resiliationZoneDesc: "Fermez définitivement votre compte et choisissez ce qu'il advient de vos données. Cette action est irréversible.",
    resiliationCta: "Résilier et quitter Notacito",
    resiliationCompany: "Entreprise à résilier",
    chooseCompany: "Choisir une entreprise",
cancelZoneDesc: "Vous conserverez l'accès jusqu'à la fin de votre période de facturation en cours.",
cancelCta: "Résilier mon abonnement",
cancelSuccess: "Votre abonnement sera résilié à la fin de la période en cours.",
cancelError: "Erreur lors de la résiliation : ",
scheduledCancellation: "Votre abonnement sera résilié à la fin de la période en cours et ne sera pas renouvelé.",
cancelConfirmTitle: "Résilier votre abonnement ?",
cancelConfirmContent: "Vous conserverez l'accès jusqu'à la fin de la période déjà payée. Confirmez-vous cette résiliation ?",
cancelConfirmBtn: "Confirmer la résiliation",
     billingPeriod: "Facturation",
  monthlyBilling: "Mensuelle",
  yearlyBilling: "Annuelle",
    plans: {
      free:       "Gratuit",
      essential:  "Essentiel",
      pro:        "Pro",
      enterprise: "Entreprise",
    },
  },

  // ── Dashboard ────────────────────────────────────────────
  dashboard: {
    title:              "Dashboard",
    subtitle:           "Vue d'ensemble des statistiques clés et de l'activité financière.",
    loading:            "Chargement des données du tableau de bord...",
    errorLoading:       "Erreur lors du chargement des données. Veuillez réessayer.",
    totalMembers:       "Total Membres",
    activeCategories:   "Catégories Actives",
    expenseReports:     "Notes de Frais",
    chartByType:        "Répartition par Type",
    chartByUsers:       "Répartition des Utilisateurs",
    chartByStatus:      "Statuts des Notes de Frais",
    chartOverTime:      "Évolution des montants dépensés (€)",
    tooltipAmount:      "{b} : {c} €",
    unknownRole:        "Inconnu",
    unknownStatus:      "UNKNOWN",
  },

  home: {
    title: "Utilisateurs",
    subtitle: "Gérez tous les utilisateurs, regroupés par entreprise.",
    totalUsers: "Total utilisateurs",
    companies: "Entreprises",
    active: "Actif",
    blocked: "Bloqué",
    left: "Parti",
    searchPlaceholder: "Rechercher par nom, email, rôle…",
    noUsersFound: "Aucun utilisateur trouvé.",
    noSearchMatch: "Aucun utilisateur ne correspond à votre recherche.",
    failedToLoad: "Échec du chargement des utilisateurs :",
    userStatusUpdated: "Statut de l'utilisateur mis à jour.",
    blockUser: "Bloquer l'utilisateur",
    activateUser: "Activer l'utilisateur",
    usersCount: "utilisateur",
    usersCountPlural: "utilisateurs",
    table: {
      name: "Nom",
      email: "Email",
      role: "Rôle",
      phone: "Téléphone",
      status: "Statut",
      access: "Accès"
    },
    page: "Page"
  },

  users: {
    unnamed: "Sans nom",
    edit: "Modifier",
    uid: "Firebase UID",
    copyUid: "Copier l'UID",
    phone: "Téléphone",
    company: "Entreprise",
    role: "Rôle",
    iban: "IBAN",
    gender: "Genre",
    birthDate: "Date de naissance",
    address: "Adresse",
    loading: "Chargement de l'utilisateur...",
    errorLoading: "Erreur : ",
    notFound: "Utilisateur introuvable.",
    cannotLoad: "Impossible de charger l'utilisateur.",
    client: "Client",
    accountant: "Comptable",
    admin: "Admin",
    updated: "Utilisateur mis à jour.",
    updateError: "Erreur lors de la mise à jour.",
    deleteConfirm: "Supprimer définitivement {name} ?",
    deleted: "Utilisateur supprimé.",
    deleteError: "Erreur lors de la suppression.",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    selectRole: "Sélectionner un rôle",
    selectGender: "Sélectionner",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    deleting: "Suppression...",
    deleteBtn: "Supprimer",
    cancelBtn: "Annuler",
    saving: "Sauvegarde...",
    saveBtn: "Enregistrer",
    saveConfirmTitle: "Confirmer l'enregistrement",
    saveConfirmContent: "Voulez-vous vraiment enregistrer les modifications apportées à cet utilisateur ?",
    deleteConfirmTitle: "Confirmer la suppression",
    ibanLengthError: "L'IBAN doit contenir exactement 21 caractères.",
    ibanMissingChars: "{count} caractère(s) manquant(s).",

  },

  addUserForm: {
  roles: {
    client: {
      title: "Ajouter un client",
      create: "Créer le client",
      success: "Le client {name} a été créé avec succès.",
      error:
        "Une erreur est survenue lors de la création du client : {message}",
    },
    admin: {
      title: "Ajouter un administrateur",
      create: "Créer l’administrateur",
      success:
        "L’administrateur {name} a été créé avec succès.",
      error:
        "Une erreur est survenue lors de la création de l’administrateur : {message}",
    },
    accountant: {
      title: "Ajouter un comptable",
      create: "Créer le comptable",
      success:
        "Le comptable {name} a été créé avec succès.",
      error:
        "Une erreur est survenue lors de la création du comptable : {message}",
    },
  },

  targetCompany: "Entreprise concernée",
  platform: "Plateforme",
  noCompanies: "Aucune entreprise disponible",

  firstName: "Prénom",
  lastName: "Nom",
  email: "Adresse e-mail",
  password: "Mot de passe",
  phoneNumber: "Numéro de téléphone",
  optional: "facultatif",

  placeholders: {
    firstName: "Saisissez le prénom",
    lastName: "Saisissez le nom",
    email: "Saisissez l’adresse e-mail",
    password: "Saisissez le mot de passe",
    phoneNumber: "Saisissez le numéro de téléphone",
  },

  cancel: "Annuler",
  creating: "Création...",
  loading: "Chargement du formulaire...",

  requiredFields:
    "Veuillez renseigner le prénom, le nom, l’adresse e-mail et le mot de passe.",
  selectCompany:
    "Veuillez sélectionner une entreprise.",
  initializationError:
    "Impossible de charger les informations nécessaires au formulaire.",
  unknownError: "Erreur inconnue",
},

  searchPlaceholderCompany: "Rechercher par nom, email, entreprise…",
  pagination: {
    result: "résultat",
    results: "résultats",
  },
  clients: {
    title: "Clients",
    subtitle: "Gérez vos clients et leurs informations.",
    addBtn: "Ajouter un client",
    total: "Total clients",
    block: "Bloquer le client",
    activate: "Activer le client",
    noMatch: "Aucun client ne correspond à votre recherche.",
    notFound: "Aucun client trouvé.",
    statusUpdated: "Statut du client mis à jour.",
    failedToLoad: "Échec du chargement des clients :",
    count: "client",
    countPlural: "clients",
    clientManagement: "la gestion des clients",
    limitExceededEmployee: "Limite d'employés atteinte pour cet abonnement. Veuillez passer au forfait supérieur."
  },
  accountants: {
    title: "Comptables",
    subtitle: "Gérez vos comptables et leurs informations.",
    addBtn: "Ajouter un comptable",
    total: "Total comptables",
    block: "Bloquer le comptable",
    activate: "Activer le comptable",
    noMatch: "Aucun comptable ne correspond à votre recherche.",
    notFound: "Aucun comptable trouvé.",
    statusUpdated: "Statut du comptable mis à jour.",
    failedToLoad: "Échec du chargement des comptables :",
    count: "comptable",
    countPlural: "comptables",
    accountantManagement: "la gestion des comptables",
    limitExceededEmployee: "Limite d'employés atteinte pour cet abonnement. Veuillez passer au forfait supérieur."

  },
  admins: {
    title: "Administrateurs",
    subtitle: "Gérez vos administrateurs et leurs informations.",
    addBtn: "Ajouter un admin",
    total: "Total admins",
    block: "Bloquer l'admin",
    activate: "Activer l'admin",
    noMatch: "Aucun admin ne correspond à votre recherche.",
    notFound: "Aucun admin trouvé.",
    statusUpdated: "Statut de l'admin mis à jour.",
    failedToLoad: "Échec du chargement des administrateurs :",
    count: "admin",
    countPlural: "admins",
    adminManagement: "la gestion des administrateurs",
    limitExceededEmployee: "Limite d'employés atteinte pour cet abonnement. Veuillez passer au forfait supérieur."
  },

  expenseReports: {
    title: "Notes de Frais",
    subtitle: "Gérez les dépenses regroupées par entreprise et employé.",
    noCompany: "Sans entreprise",
    unknownUser: "Inconnu",
    statusDraft: "Brouillon",
    statusPending: "En attente",
    statusApproved: "Approuvé",
    statusReimbursed: "Remboursé",
    statusRejected: "Rejeté",
    pendingAlertSingle: "dépense en attente",
    pendingAlertPlural: "dépenses en attente",
    pendingLabel: "en attente",
    approvedAlertSingle: "dépense approuvée",
    approvedAlertPlural: "dépenses approuvées",
    approvedLabel: "approuvé",
    noAlerts: "Aucune alerte",
    monthTotal: "Total du mois",
    noExpenses: "Aucune dépense",
    reportCountSingle: "note",
    reportCountPlural: "notes",
    userCountSingle: "utilisateur",
    userCountPlural: "utilisateurs",
    noExpensesThisMonth: "Aucune dépense ce mois-ci.",
    showingExpensesFor: "Affichage des dépenses de",
    only: "uniquement",
    noUsersMatch: "Aucun utilisateur ne correspond à votre recherche.",
    showingSearchMatch: "Affichage des dépenses du mois pour les utilisateurs correspondant à",
    noReportsFound: "Aucune note de frais trouvée.",
    tableSupplier: "Fournisseur",
    tableCategory: "Catégorie",
    tableDate: "Date",
    tableAmount: "Montant",
    tableVat: "TVA",
    tableStatus: "Statut",
    statTotalReports: "Total notes",
    statCompanies: "Entreprises",
    statMonthTotal: "Total du mois",
    statPending: "En attente",
    statApproved: "Approuvé",
    statReimbursed: "Remboursé",
    searchPlaceholder: "Rechercher par nom ou email → affiche leurs dépenses du mois",
    failedToLoad: "Échec du chargement des notes de frais :",
     filterTitle:          "Filtrer",
    filterClear:          "Réinitialiser",
    filterAll:            "Tous",
    filterYear:           "Année",
    filterMonth:          "Mois",
    filterCategory:       "Catégorie",
    filterStatus:         "Statut",
  },

  editExpenseReport: {
  title: "Modifier la note de frais",
  subtitle: "Mettez à jour les informations de la note de frais.",

  fields: {
    supplierName: "Nom du fournisseur",
    receiptNumber: "Numéro du justificatif",
    expenseDate: "Date de la dépense",
    comment: "Commentaire",
    distanceKm: "Distance (km)",
    vehiclePowerCv: "Puissance du véhicule (CV)",
    vehicleType: "Type de véhicule",
    energyType: "Type d’énergie",
    mileageRateYear: "Année du barème kilométrique",
    participantCount: "Nombre de participants",
  },

  placeholders: {
    supplierName: "Nom du fournisseur",
    receiptNumber: "Numéro du justificatif",
    optionalComment: "Commentaire facultatif",
    vehicleType: "VOITURE, MOTO...",
    energyType: "ESSENCE, ÉLECTRIQUE...",
    mileageRateYear: "2026",
    zero: "0",
  },

  cancel: "Annuler",
  saving: "Enregistrement...",
  saveChanges: "Enregistrer les modifications",

  success: "La note de frais a été mise à jour avec succès.",
  error: "Impossible de mettre à jour la note de frais.",
},

  expenseReportDetails: {
  title: "Note de frais",

  loading: "Chargement de la note de frais...",

  errors: {
    generic: "Erreur : {message}",
    notFound: "Note de frais introuvable.",
    attachmentsNotFound: "Justificatifs introuvables.",
  },

  status: {
    draft: "Brouillon",
    pending: "En attente",
    approved: "Approuvée",
    rejected: "Rejetée",
    reimbursed: "Remboursée",
  },

  sections: {
    items: "Éléments de la dépense",
    attachments: "Justificatifs",
  },

  fields: {
    amount: "Montant",
    receiptNumber: "Numéro de reçu",
    expenseDate: "Date de la dépense",
    vatAmount: "Montant de la TVA",
    submittedAt: "Date de soumission",
    comment: "Commentaire",
    distance: "Distance",
    vehiclePower: "Puissance du véhicule",
    vehicleType: "Type de véhicule",
    energyType: "Type d'énergie",
    mileageRateYear: "Année du barème kilométrique",
    calculatedReimbursement: "Remboursement calculé",
    participants: "Participants",
    company: "Entreprise",
    user: "Utilisateur",
    category: "Catégorie",
  },

  itemFields: {
    type: "Type",
    quantity: "Quantité",
    unitAmountTtc: "Prix unitaire TTC",
    totalAmountTtc: "Total TTC",
    vatRate: "Taux de TVA",
    vatAmount: "Montant de la TVA",
    amountHt: "Montant HT",
    vatRecoverable: "TVA récupérable",
  },

  actions: {
    approve: "Approuver",
    reject: "Rejeter",
    markAsReimbursed: "Marquer comme remboursée",
    openFull: "Ouvrir en grand",
    download: "Télécharger",
  },

  empty: {
    items: "Aucun élément trouvé.",
    attachments: "Aucun justificatif trouvé.",
  },

  attachments: {
    receiptAlt: "Justificatif de la note de frais",
    loadingPreview: "Chargement de l'aperçu...",
  },

  confirm: {
    deleteReport:
      "Voulez-vous vraiment supprimer cette note de frais ?",
    deleteItem:
      "Voulez-vous vraiment supprimer cet élément de dépense ?",
    changeStatus:
      "Voulez-vous vraiment passer le statut à « {status} » ?",
  },

  alerts: {
    reportDeleted:
      "La note de frais a été supprimée avec succès.",
    reportDeleteError:
      "Impossible de supprimer la note de frais.",
    itemDeleted:
      "L'élément de dépense a été supprimé avec succès.",
    itemDeleteError:
      "Impossible de supprimer l'élément de dépense.",
    attachmentOpenError:
      "Impossible d'ouvrir le justificatif.",
    statusUpdated:
      "La note de frais est maintenant « {status} ».",
    statusUpdateError:
      "Impossible de modifier le statut de la note de frais.",
  },

  fileSize: {
    bytes: "o",
    kilobytes: "Ko",
    megabytes: "Mo",
  },

 

  vehicleTypes: {
    car: "Voiture",
    motorcycle: "Moto",
    scooter: "Scooter",
    bicycle: "Vélo",
  },

  energyTypes: {
    petrol: "Essence",
    gasoline: "Essence",
    diesel: "Diesel",
    electric: "Électrique",
    hybrid: "Hybride",
    lpg: "GPL",
  },
},


officeDetailsCard: {
  structureType: "Type de structure",
  platformSystem: "🛡️ Plateforme principale",
  clientCompany: "🏢 Entreprise cliente",
  id: "Identifiant",
  cancel: "Annuler",
  deleteOffice: "Supprimer le bureau",
  deleteConfirm:
    'Voulez-vous vraiment supprimer le bureau « {name} » ?',
  deleteSuccess: "Le bureau a été supprimé avec succès.",
  deleteError: "Impossible de supprimer le bureau.",
},

addOffice: {
  title: "Ajouter un nouveau bureau",
  officeName: "Nom du bureau",
  officeNamePlaceholder:
    "Saisissez le nom de l’entreprise ou du client",
  isMainPlatform:
    "S’agit-il de la plateforme principale de Notacito ?",
  cancel: "Annuler",
  creating: "Création...",
  createOffice: "Créer le bureau",
  nameRequired: "Le nom du bureau est obligatoire.",
  createSuccess: "Le bureau a été créé avec succès.",
  createError:
    "Erreur lors de la création du bureau : {message}",
},

categoryTypes: {
  standard: "Standard",
  meal: "Restauration",
  housing: "Logement",
  travel: "Déplacement",
  office: "Bureau",
  training: "Formation",
  provider: "Fournisseur",
  vehicle: "Véhicule",
  equipment: "Équipement",
   fuel: "Carburant",
  phone: "Téléphone",
  pressing: "Pressing",
  other: "Autre",
},

categoryDetails: {
  unnamed: "Sans nom",
  noCompany: "Aucune entreprise",
  cancel: "Annuler",
  deleteCategory: "Supprimer la catégorie",
  editCategory: "Modifier la catégorie",
  deleteConfirm:
    'Voulez-vous vraiment supprimer la catégorie « {name} » ?',
  deleteSuccess:
    "La catégorie a été supprimée avec succès.",
  deleteError:
    "Impossible de supprimer la catégorie.",
},

patchCategory: {
  title: "Modifier la catégorie",
  categoryType: "Type de catégorie",
  loading: "Chargement...",
  cancel: "Annuler",
  saving: "Enregistrement...",
  saveChanges: "Enregistrer les modifications",
  fetchError:
    "Erreur lors du chargement de la catégorie.",
  updateSuccess:
    "La catégorie a été mise à jour avec succès.",
  updateError:
    "Erreur lors de la mise à jour de la catégorie : {message}",
},

addCategory: {
  title: "Ajouter une nouvelle catégorie",
  targetCompany: "Entreprise concernée",
  categoryType: "Type de catégorie",
  platform: "Plateforme",
  cancel: "Annuler",
  creating: "Création...",
  createCategory: "Créer la catégorie",
  loading: "Chargement du formulaire...",
  selectCompany:
    "Veuillez sélectionner une entreprise.",
  requirementsError:
    "Impossible de charger les informations nécessaires au formulaire.",
  createSuccess:
    "La catégorie a été créée avec succès.",
  createError:
    "Erreur lors de la création de la catégorie : {message}",
},

categoriesPage: {
  title: "Catégories",

  accountantSubtitle:
    "Consultez les catégories disponibles pour votre entreprise.",
  managementSubtitle:
    "Gérez vos catégories et leurs informations.",

  addCategory: "Ajouter une catégorie",

  totalCategories: "Total des catégories",
  companiesAffected: "Entreprises concernées",

  searchPlaceholder:
    "      Rechercher une catégorie par type ou par nom...",

  noCategories: "Aucune catégorie trouvée.",
  noSearchMatch:
    "Aucune catégorie ne correspond à votre recherche.",

  noCompany: "Global / Aucune entreprise",

  typeName: "Type / Nom",

  categorySingle: "catégorie",
  categoryPlural: "catégories",

  page: "Page",

  loadingError:
    "Impossible de charger les catégories : {message}",
  unknownError: "Erreur inconnue",

  featureName: "la gestion des catégories",
},

settingsForm: {
  pageTitle: "Paramètres",
  selectCompany: "Sélectionnez une entreprise",
  chooseCompany: "Choisissez une entreprise",
  selectCompanyPrompt: "Veuillez sélectionner une entreprise pour gérer ses paramètres.",
  gamification: {
    title: "⚙️ Gamification",
    description:
      "Configurez le classement d’engagement pour les notes de frais de votre équipe.",

    enabledLabel: "Activer la gamification",
    enabledDescription:
      "Active ou désactive le classement et l’attribution de flammes.",

    deadlineLabel: "Jour limite",
    deadlineDescription:
      "Le jour du mois où les notes de frais sont attendues, par exemple le 10.",
  },
  mileageRates: {
  title: "Barèmes Kilométriques",
  description: "Configurez les taux de remboursement basés sur le type de véhicule, la puissance et la distance.",

  mode: {
    notacitoTitle: "Barèmes Notacito",
    customTitle: "Barèmes personnalisés",
    notacitoDescription:
      "Les mises à jour publiées par Notacito sont appliquées automatiquement à cette entreprise.",
    customDescription:
      "Cette entreprise utilise ses propres barèmes. Lorsqu'aucun barème personnalisé ne correspond, le barème Notacito peut être utilisé en secours.",
    switchToCustom: "Personnaliser les barèmes",
    switchToNotacito: "Utiliser les barèmes Notacito",
    updating: "Mise à jour...",
    switchToNotacitoSuccess: "Les barèmes Notacito sont maintenant utilisés",
    switchToCustomSuccess: "Les barèmes personnalisés sont maintenant activés",
    switchError: "Impossible de modifier le mode des barèmes : {message}",
    noCompanySelected: "Aucune entreprise sélectionnée",
    managedByNotacito: "Géré par Notacito",
    toggleTitleEditable: "Cliquer pour basculer le statut",
    toggleTitleLocked: "Ce barème est géré par Notacito",
  },

  nationalDefaultOption: "— Barèmes nationaux / par défaut —",

  addRate: "Ajouter un barème",
  ratesCountLabel: "barème(s) pour {year}",
  activeCountLabel: "actif(s)",

  columnEnergy: "Énergie",
  columnPower: "CV (min–max)",
  columnDistance: "Distance (km)",
  columnFixed: "Fixe",
  columnPerKm: "Par km",
  columnStatus: "Statut",
  columnActions: "Actions",
  allEnergies: "Toutes",
  statusActive: "Actif",
  statusInactive: "Inactif",
  edit: "Modifier",
  delete: "Supprimer",

  noRates: "Aucun barème kilométrique configuré pour cette année.",
  noNotacitoRates: "Aucun barème Notacito configuré pour cette année.",
  noCustomRates: "Aucun barème personnalisé configuré pour cette année.",

  loading: "Chargement des barèmes...",

  vehicleTypes: {
    car: "Voiture",
    motorbike: "Moto",
    moped: "Scooter / Cyclomoteur",
  },

  energyTypes: {
    thermal: "Thermique / Hybride / Hydrogène",
    electric: "Électrique",
    hybrid: "Hybride",
    hydrogen: "Hydrogène",
  },

  modalCreateTitle: "Nouveau barème kilométrique",
  modalEditTitle: "Modifier le barème",
  modalClose: "Fermer",

  fieldYear: "Année",
  fieldVehicleType: "Type de véhicule",
  fieldEnergyType: "Énergie",
  fieldAllEnergies: "Toutes énergies",
  fieldStatus: "Statut",

  sectionPower: "Puissance fiscale (CV)",
  sectionDistance: "Distance parcourue (km)",
  sectionAmounts: "Montants",

  fieldMin: "Min",
  fieldMax: "Max",
  fixedAmount: "Montant fixe (€)",
  perKmAmount: "Montant par km (€)",

  previewLabel: "Exemple : pour {distance} km, remboursement ≈ {amount} €",

  cancel: "Annuler",
  saveRate: "Créer le barème",
  updateRate: "Mettre à jour",
  saving: "Enregistrement...",

  errors: {
    yearInvalid: "Année invalide",
    vehicleTypeRequired: "Type de véhicule requis",
    mustBePositive: "Doit être ≥ 0",
    maxMustBeGreaterThanMin: "Le max doit être ≥ au min",
  },

  deleteConfirmTitle: "Supprimer ce barème ?",
  deleteConfirmMessage:
    "Le barème {vehicleType} ({powerMin}-{powerMax} CV) sera définitivement supprimé.",
  deleteConfirmBtn: "Supprimer",

  saveSuccess: "Barème enregistré avec succès",
  saveError: "Échec de l'enregistrement : {message}",
  statusUpdateError: "Échec de la mise à jour du statut : {message}",
  deleteSuccess: "Barème supprimé",
  deleteError: "Échec de la suppression : {message}",
},

  saving: "Enregistrement...",
  saveChanges: "Enregistrer les modifications",

  updateSuccess:
    "Les paramètres ont été mis à jour avec succès !",
  updateError:
    "Erreur lors de la mise à jour : {message}",

  featureName: "la gestion de la gamification",
},



editExpenseReportItem: {
  title: "Modifier un élément de dépense",
  subtitle: "Mettez à jour les informations de l’élément de dépense.",

  fields: {
    label: "Libellé",
    itemType: "Type de dépense",
    quantity: "Quantité",
    unitAmountTtc: "Montant unitaire TTC",
    totalAmountTtc: "Montant total TTC",
    vatRate: "Taux de TVA",
    vatAmount: "Montant de la TVA",
    amountHt: "Montant HT",
    vatRecoverable: "TVA récupérable",
    comment: "Commentaire",
  },

  itemTypes: {
    standard: "Standard",
  meal: "Restauration",
  housing: "Logement",
  travel: "Déplacement",
  office: "Bureau",
  training: "Formation",
  provider: "Fournisseur",
  vehicle: "Véhicule",
  equipment: "Équipement",
   fuel: "Carburant",
  phone: "Téléphone",
  pressing: "Pressing",
  other: "Autre",
  },

  yes: "Oui",
  no: "Non",
  cancel: "Annuler",
  saving: "Enregistrement...",
  save: "Enregistrer l’élément",

  success: "L’élément de dépense a été mis à jour avec succès.",
  error: "Impossible de mettre à jour l’élément de dépense.",
},

  

  offices: {
    title: "Bureaux",
    subtitle: "Gérez les bureaux de votre entreprise",
    loading: "Chargement des bureaux...",
    errorLoading: "Erreur lors du chargement des bureaux :",
    noOffices: "Aucun bureau disponible.",
    addBtn: "Ajouter un bureau",
  },

  officeCell: {
    noName: "Sans nom",
    mainPlatform: "Plateforme Principale",
    standardCorporate: "Entreprise Classique",
  },
  officeDetails: {
    loading: "Chargement des détails du bureau...",
    errorPrefix: "Erreur : ",
    notFound: "Bureau introuvable.",
  },

  companyPolicies: {
    title: "Politiques d'Entreprise",
    loading: "Chargement des politiques...",
    deleteSuccess: "Politique supprimée avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette politique ?",
    addBtn: "Ajouter une Politique",
    deleting: "Suppression...",
    deleteBtn: "Supprimer la Politique",
    editBtn: "Modifier les Règles",
    status: "Statut",
    dailyLimit: "Limite Journalière",
    vatRule: "Règle de TVA",
    receiptRequired: "Reçu Requis",
    selectCompany: "Sélectionnez une entreprise",
    chooseCompany: "Choisissez une entreprise",
    manualVat: "TVA Manuelle",

    active: "Active",
    allowed: "Autorisé ✅",
    forbidden: "Interdit ❌",
    noLimit: "Aucune limite",
    yes: "Oui",
    no: "Non",
    selectCategory: "Sélectionnez une catégorie pour voir les détails.",
    featureName: "la gestion des politiques d'entreprise",

  },

  companyPolicyForm: {
          saveConfirmContent: "Voulez-vous vraiment enregistrer les modifications apportées à cet utilisateur ?",

  editTitle: "Modifier la politique",
  editSubtitle:
    "Ajustez les plafonds et les exigences pour cette catégorie de dépense.",

  createTitle: "Créer une nouvelle politique",
  createSubtitle:
    "Configurez une nouvelle règle de dépense pour votre entreprise.",

  loading: "Chargement...",

  fields: {
    category: "Sélectionner une catégorie",
    spendingLimit: "Plafond de dépense (€)",
    maxWithoutReceipt: "Maximum sans justificatif (€)",
    vatRuleType: "Type de règle de TVA",
    status: "Statut",
  },

  placeholders: {
    chooseCategory: "Choisir une catégorie",
    noLimit: "Aucun plafond",
    zero: "0",
  },

  vatRules: {
    none: "Aucune",
    manual: "Manuelle",
    sumLines: "Somme des lignes",
  },

  statuses: {
    active: "Active",
    inactive: "Inactive",
  },

  conditionsTitle: "Conditions et justificatifs",

  conditions: {
    allowed: "Autorisé",
    requiresReceipt: "Justificatif obligatoire",
    allowsVat: "TVA autorisée",
    allowsManualVat: "TVA manuelle autorisée",
    requiresComment: "Commentaire obligatoire",
    requiresSupplierName: "Nom du fournisseur obligatoire",
    allowsDistanceKm: "Kilométrage autorisé",
    allowsFuelExpense: "Dépense de carburant",
    allowCompanyCar: "Véhicule de fonction",
    allowPersonalCar: "Véhicule personnel",
  },

  cancel: "Annuler",
  saving: "Enregistrement...",
  saveChanges: "Enregistrer les modifications",
  creating: "Création...",
  createPolicy: "Créer la politique",

  updateSuccess: "La politique a été mise à jour avec succès.",
  updateError:
    "Impossible de mettre à jour la politique : {message}",
  createSuccess: "La politique a été créée avec succès.",
  createError:
    "Impossible de créer la politique : {message}",
  loadError: "Impossible de charger la politique.",
  categoriesLoadError:
    "Impossible de charger les catégories.",
},


  corporate: {
    loading: "Chargement des statistiques...",
    errorLoading: "Échec du chargement des statistiques. Veuillez réessayer.",
    title: "Engagement Corporatif",
    subtitle: "Suivez la ponctualité de l'équipe et l'engagement sur les notes de frais.",
    statActive: "Employés Actifs",
    statTopStreak: "Meilleure Série",
    statTotalFlames: "Total Flammes Équipe",
    liveLeaderboard: "🏆 Classement en Direct",
    liveBadge: "En Direct",
    noActiveParticipants: "Aucun participant actif pour le moment.",
    historicalPodium: "📊 Podium Historique",
    btnSnapshot: "📸 Figer",
    btnSaving: "Sauvegarde...",
    snapshotSuccess: "Photo du classement enregistrée pour",
    snapshotError: "Erreur lors de la sauvegarde :",
    snapshotConfirm: "Voulez-vous figer le classement actuel pour le mois {month}/{year} ? Cela écrasera l'historique existant pour ce mois.",
    noDataRecorded: "Aucune donnée enregistrée pour ce mois.",
    howItWorksTitle: "💡 Comment ça marche",
    howItWorksL1: "Gagner des flammes : Les employés gagnent 1 flamme maximum par mois en soumettant leurs dépenses avant la date limite.",
    howItWorksL2: "Pénalités : Rater la date limite fait perdre 1 flamme (vous ne perdez pas tout d'un coup !).",
    howItWorksL3: "Paliers : Maintenez la série jusqu'à 12 flammes pour débloquer des badges (Bronze à 4, Argent à 8, Or à 12).",
    howItWorksL4: "Historique : Le podium est figé le dernier jour de chaque mois.",
    chartTitle: "Top 10 du mois"
  },
  upgrade: {
  back: "Retour",
  ratingText: "La gestion des dépenses simplifiée",
  title: "Choisissez l’offre adaptée à",
  titleHighlight: "votre entreprise",
  tooManyEmployees: "Votre entreprise compte {count} employé(s), ce forfait est limité à {limit}.",

  subtitle:
    "Centralisez, validez et suivez les notes de frais de vos salariés depuis une seule plateforme.",

  monthly: "Mensuel",
  yearly: "Annuel",
  yearlyDiscount: "-10 %",

  mostPopular: "LE PLUS POPULAIRE",
  perMonth: "/ mois",
  billed: "Facturé",
  perYear: "par an",
  noPaymentRequired: "Aucun moyen de paiement requis",

  redirecting: "Redirection...",
  continueFree: "Continuer gratuitement",
  choosePlan: "Choisir cette offre",

  errors: {
    planNotConfigured:
      "Ce plan n'est pas encore configuré pour le paiement.",
    checkoutUrlMissing:
      "URL de paiement introuvable.",
    checkoutFailed:
      "Impossible d’ouvrir la page de paiement. Veuillez réessayer.",
  },

  reassurance: {
    securePaymentTitle: "Paiement sécurisé",
    securePaymentText:
      "Les paiements seront traités par Stripe.",
    noCommitmentTitle: "Sans engagement",
    noCommitmentText:
      "Vous pourrez résilier votre abonnement.",
    helpTitle: "Besoin d’aide ?",
    helpText:
      "Notre équipe vous accompagne dans votre installation.",
  },

  plans: {
    free: {
      name: "Découverte",
      description:
        "Découvrez Notacito avec un accès limité aux fonctionnalités.",
      features: {
        employees: "Jusqu’à 1 salarié",
        expenses: "36 scans de justificatifs par an (saisie manuelle illimitée)",
        manualCreation:
          "Création manuelle des dépenses",
        automaticScan:
          "Scan automatique des justificatifs",
        validation:
          "Validation des notes de frais",
        accountingExports: "Exports comptables",
        prioritySupport: "Support prioritaire",
      },
    },

    essential: {
      name: "Essentiel",
      description:
        "Pour les petites entreprises souhaitant centraliser leurs dépenses.",
      features: {
        employees: "Jusqu’à 10 salariés",
        expenses:
          "Jusqu'à 2 400 scans de justificatifs par an (saisie manuelle illimitée)",
        automaticScan:
          "Scan automatique des justificatifs",
        validation: "Circuit de validation",
        accountingExports: "Exports comptables",
        dashboard:
          "Tableau de bord administrateur",
        emailSupport: "Support par e-mail",
      },
    },

    business: {
      name: "Business",
      description:
        "L’offre complète pour gérer efficacement les dépenses de votre équipe.",
      features: {
        employees: "Jusqu’à 30 salariés",
        expenses:
          "Jusqu'à 7 200 scans de justificatifs par an (saisie manuelle illimitée)",
        automaticScan:
          "Scan automatique des justificatifs",
        advancedValidation:
          "Circuits de validation avancés",
        accountingExports: "Exports comptables",
        roles:
          "Gestion des rôles et permissions",
        prioritySupport: "Support prioritaire",
      },
    },

    enterprise: {
      name: "Entreprise",
      description:
        "Une solution adaptée aux entreprises ayant des besoins importants.",
      features: {
        employees: "Jusqu’à 50 salariés",
        expenses:
          "Jusqu'à 12 000 scans de justificatifs par an (saisie manuelle illimitée)",
        businessFeatures:
          "Toutes les fonctionnalités Business",
        personalSupport:
          "Accompagnement personnalisé",
        bulkImport:
          "Import des salariés en masse",
        customConfiguration:
          "Configuration sur mesure",
        dedicatedSupport:
          "Support prioritaire dédié",
      },
    },
}
},
notifications: {
  title: "Notifications",
  subtitle: "Gérez vos alertes et l'activité de votre entreprise.",

  markAllAsRead: "Tout marquer comme lu",
  markingAllAsRead: "Mise à jour...",
  close: "Fermer et revenir en arrière",

  tabs: {
    all: "Toutes",
    unread: "Non lues",
  },

  loading: "Chargement de vos notifications...",

  emptyTitle: "Aucune notification",
  emptyMessage: "Vous êtes à jour ! Il n'y a rien à afficher ici pour le moment.",

  noUnreadTitle: "Aucune notification non lue",
  noUnreadMessage: "Vous avez lu toutes vos notifications.",

  types: {
    [NotificationType.expenseSubmitted]: {
      title: "Note de frais soumise",
      message: "Votre note de frais a bien été soumise pour validation.",
    },
    [NotificationType.expenseApproved]: {
      title: "Note de frais approuvée",
      message: "Votre note de frais a été approuvée.",
    },
    [NotificationType.expenseRejected]: {
      title: "Note de frais rejetée",
      message: "Votre note de frais a été rejetée.",
    },
    [NotificationType.expenseReimbursed]: {
      title: "Note de frais remboursée",
      message: "Votre note de frais a été remboursée.",
    },
    [NotificationType.policyUpdated]: {
      title: "Politique mise à jour",
      message: "La politique de dépenses de votre catégorie a été mise à jour.",
    },
    [NotificationType.mileageRateUpdated]: {
      title: "Barème kilométrique mis à jour",
      message: "Le barème kilométrique applicable a été mis à jour.",
    },
  } satisfies Record<NotificationType, { title: string; message: string }>,
},

  // ── Authentification ─────────────────────────────────────
 auth: {
    login:          "Se connecter",
    loginTitle:     "Connexion",
    email:          "Adresse email",
    password:       "Mot de passe",
    required:       "Un mail est requis",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser le mot de passe",
    resetPasswordTitle: "Réinitialisation du mot de passe",
    resetPasswordSuccess: "Un email de réinitialisation a été envoyé à {email}.",
    resetPasswordError: "Erreur lors de la réinitialisation du mot de passe : {message}",
    sendResetEmail: "Envoyer l'email de réinitialisation",
    backToLogin: "Retour à la connexion",
    noAccount:      "Pas encore de compte ?",
    register:       "S'inscrire",
    loginError:     "Email ou mot de passe incorrect",
    or: "ou",
    googleLogin: "Se connecter avec Google",
    signingIn: "Connexion...",
    subtitle: "Accès réservé aux administrateurs",
    noAdminAccess: "Tu n'as pas les droits pour accéder au panneau d'administration.",
    profileError: "Erreur lors de la récupération du profil.",
    fillBothFields: "Veuillez remplir les deux champs.",
    loginFailed: "Échec de la connexion.",
    incompleteUser: "Les informations de l'utilisateur sont incomplètes.",
    firebaseError: "Erreur Firebase :",
    unknownError: "Une erreur est survenue",
  },

  // ── Erreurs ──────────────────────────────────────────────
  errors: {
    required:     "Ce champ est requis",
    invalidEmail: "Email invalide",
    networkError: "Erreur réseau, veuillez réessayer",
    unauthorized: "Session expirée, veuillez vous reconnecter",
    notFound:     "Page introuvable",
  },

};

export default fr;

